import { I18n } from "i18n-js";
import en from './locales/en';
import es from './locales/es';
import ca from './locales/ca';

const i18n = new I18n({en, es, ca});
const savedLanguage = localStorage?.getItem("language");
const locale = savedLanguage || navigator.language
i18n.locale = locale.substring(0,2);

export default i18n;